
import Form from 'react-bootstrap/Form';
import { useState,useMemo  } from "react";
import '../../css/SelectProductQty.css';
import StocknameConverter from '../converter/StocknameConverter.js';
import  createHash from '../shared/CreateHash.js';

function SelectProductQty(props){
  const [placeholder, setPlaceholder] = useState("");
  const [maxLength, setMaxLength] = useState("");
  const [itemsChecked, setItemsChecked] = useState([]);
  const [scanInput, setScanInput] = useState("");
  const isRedPacketEvent = props.isRedPacketEvent ?? false;

  const CheckRemarks = (remarks) => {
    //log("remarks", remarks);
    //console.log(remarks != null);
    //console.log(remarks != "");
    //console.log(remarks != undefined);
    return remarks != null && remarks != "" && remarks != undefined;
  }

  if(isRedPacketEvent)
  {
    const redPacketEventProductImageMapping = props.redPacketEventProductImageMapping;
    var lang = props.lang;

    //console.log(lang);

   // if(CheckRemarks(remarks) && props.item_Details!=null && props.item_Details.length > 0)
   if (props.item_Details!=null && props.item_Details.length > 0) 
   {
      for(var i=0;i<props.item_Details.length;i++)
      {
        var item = props.item_Details[i];
        var profileId = "";
        var imageUrl = "";
        var imageRemark = props.remarks
        
        if (lang === "TC")
        {
            profileId = redPacketEventProductImageMapping.find(mapping => mapping.productCode == item.Item_Code)?.imageProfileIdTc;
        }
        else if (lang === "SC")
        {
            profileId = redPacketEventProductImageMapping.find(mapping => mapping.productCode == item.Item_Code)?.imageProfileIdSc;
        }

        if (profileId != null && profileId != "" && profileId != undefined && imageRemark != "")
        {
            //lang
            if (profileId.substring(0,4) === "TC_E" && imageRemark.length == 1)
            {
              imageRemark = imageRemark + "記";
            }
            else if (profileId.substring(0,4) === "SC_E" && imageRemark.length == 1)
            {
              imageRemark = imageRemark + "记";
            }


          var hash = createHash(imageRemark + "&" + profileId);
          //var hash = "05d068bb32eaaa77a49c03d5c3cde6d1f99dddba5f74b54e2ef73d8a69cb3759";
          var imageBaseUrl = process.env.REACT_APP_RED_PACKET_EVENT_IMAGE_URL;
          var imageBeforeGenBaseUrl = process.env.REACT_APP_RED_PACKET_EVENT_IMAGE_BEFORE_GEN_URL;

          /*CHECK IF GEN WORD BEFORE*/
          imageUrl = imageBaseUrl + "frontend/api/ImageGeneration/Generate?word=" + imageRemark + "&profileId=" + profileId + "&hash=" + hash;
          
        }
        else
        {
          imageUrl  = redPacketEventProductImageMapping.find(mapping => mapping.productCode == item.Item_Code)?.defaultImageLink;
        }

       // console.log(imageUrl);
       // console.log(remarks);
        props.item_Details[i].previewUrl = imageUrl;
        props.item_Details[i].remarks = imageRemark;

      }
    }
  }

  //console.log(props.item_Details);
    const geoHandleChange = (e) => {
        let geoItem = FindArrayElementByValue(props.item_Details, e.target.value);
        //setPlaceholder(geoItem.placeHolder);
        //setMaxLength(geoItem.maxLength);
        //setPhoneno("");
        //props.setMobile(e);
    }

   const ClearItemsChecked = () => {
      setItemsChecked([]);
    }

    const ClearItemsCheckedWithItemCode = (e) => {
      for (let i = 0; i < props.item_Details.length; i++) 
      {
          const item = props.item_Details[i];
          if (item.Item_Code === e)
          {
            item.SelectedQty = 0;

            let itemChecked = FindArrayElementByItemCode(itemsChecked, item.Item_Code);
            let newitemsChecked = [...itemsChecked]; 
            if (typeof(itemChecked) !== 'undefined' && itemChecked != null) 
            {
              for (var j=0;j<newitemsChecked.length;j++)
              {
                if (newitemsChecked[j].Item_Code == item.Item_Code)
                {
                  newitemsChecked[j].value= 0;
                }
              }
            }
            else
            {
            newitemsChecked = newitemsChecked.concat({Item_Code:item.Item_Code, value: 0});
            }
            setItemsChecked(newitemsChecked);
            props.setItemQty(item.Item_Code,0);
          }

      }  
      //setItemsChecked([]);
    }


    props.passClearSelectedItems(ClearItemsChecked);

    const SelectQtyChange = (e) => {
      let itemChecked = FindArrayElementByItemCode(itemsChecked, e.target.name);
      let newitemsChecked = [...itemsChecked]; 
      if (typeof(itemChecked) !== 'undefined' && itemChecked != null) {
        for (var i=0;i<newitemsChecked.length;i++)
        {
          if (newitemsChecked[i].Item_Code == e.target.name)
          {
            newitemsChecked[i].value=e.target.value;
          }
        }
      }
      else
      {
        newitemsChecked = newitemsChecked.concat({Item_Code:e.target.name, value:e.target.value});
      }
      setItemsChecked(newitemsChecked);
      props.setItemQty(e.target.name,e.target.value);
  }

    const handleKeyPress = (e) => {
      if(e.charCode==13){
        let item = FindArrayElementByItemCode(props.item_Details, scanInput);
        
        if (typeof(item) !== 'undefined' && item != null) {
          let itemChecked = FindArrayElementByItemCode(itemsChecked, scanInput);
          
            let newitemsChecked = [...itemsChecked]; 
            if (typeof(itemChecked) !== 'undefined' && itemChecked != null) {
              for (var i=0;i<newitemsChecked.length;i++)
              {
                if (newitemsChecked[i].Item_Code == item.Item_Code)
                {
                  if (parseInt(newitemsChecked[i].value,10) < item.Item_Max_Qty)
                  {
                    newitemsChecked[i].value=parseInt(newitemsChecked[i].value,10)+1;
                    props.setItemQty(item.Item_Code,newitemsChecked[i].value);
                  }
                  else
                    alert("已到達上限");
                }
              }
            }
            else
            {
              newitemsChecked = newitemsChecked.concat({Item_Code:item.Item_Code, value:1});
              props.setItemQty(item.Item_Code,1);
            }
            setItemsChecked(newitemsChecked);
            setScanInput("");
        }
        else
        {
          alert("貨品不存在");
          setScanInput("");
        }
      } 
    }

    
    const onChange = (e) => {
      setScanInput(e.target.value);
    }
    return <>
    <Form.Group className="mb-3" >
    <Form.Control type="text" onKeyPress={ e => { handleKeyPress(e); }}  onInput={onChange} value={scanInput}  hidden={!props.isShowScanInput} />
    <br></br>
    {props.item_Details.map((item) => 
    <div key={item.Item_Code} >
    <div className="divFlexHeader"> 
      <div className="divFlexRight">
        {
          item.Is_Available ? 
          <StocknameConverter  isRedPacketEvent={isRedPacketEvent} itemname={item.Item_Name} itemspec={item.Item_Spec} itempreviewurl={item.previewUrl} remarks={item.remarks} lang={props.lang} image_Generatation_Status={props.image_Generatation_Status} handlePreviewTask={props.handlePreviewTask}></StocknameConverter> :         
         //item.Item_Name + item.Item_Spec :
          <span>
            <del>{item.Item_Name}</del>
            <span className="soldOut">&nbsp;已售罄</span>
          </span>
        }
       
      </div>                                    
      <div>
        HK$ {item.Item_ActualPrice}
      </div>                          
    </div>
    <button type="button"  onClick={() => ClearItemsCheckedWithItemCode(item.Item_Code)}>重置</button>
    &nbsp; &nbsp;
    <PrintRadio groupName={item.Item_Code} key={item.Item_Code} Item_Min_Qty={item.Item_Min_Qty} Item_Max_Qty={item.Item_Max_Qty} description={item.Item_Name} value={item.Item_Code} passEvent={SelectQtyChange} itemsChecked={itemsChecked} itemsAvailable={item.Is_Available}></PrintRadio> 
    <br></br>取貨日期 {item.Available_PickupDate_From} 至 {item.Available_PickupDate_To}
    
    <div className="divFlexHeader"> 
      <div className="divFlexRight">
        小計
      </div>                                    
      <div>
        HK$ {item.SubTotal}
      </div>                          
    </div> 
    <hr className="Step3HR"></hr>   
    <br></br>
    </div>
    )}
    <div className="divFlexHeader"> 
      <div className="divFlexRight">
        總計
      </div>                                    
      <div>
        HK$ {props.totalAmount}
      </div>                          
    </div> 
    <hr className="Step3HR"></hr>
    </Form.Group>
  </>
}

function PrintRadio(props){
    const arr = new Array();
    for (var i=props.Item_Min_Qty;i<=props.Item_Max_Qty;i++)
    {
      arr.push(i);
    }

    return arr.map((i) => <Form.Check inline="true" type="radio" name={props.groupName} key={props.groupName+i} checked={(FindCheckedValue(props.itemsChecked,props.groupName)) == i} label={i} value={i} onChange={ e => {  props.passEvent(e)}} disabled={!props.itemsAvailable} ></Form.Check>)
  }

function FindArrayElementByValue(array, value) {
    return array.find((element) => {
      return element.value === value;
    })
  }

function FindArrayElementByItemCode(array, value) {
  return array.find((element) => {
    return element.Item_Code === value;
  })
}

function FindCheckedValue(array, value) {
  let item = FindArrayElementByItemCode(array, value);
  if (typeof(item) !== 'undefined' && item != null) {
    return item.value;
  }
  return null;
}

export default SelectProductQty;
